const normalizeRoute = (value: string) =>
    value.toLowerCase().replace(/^\/+/, '').replace(/\/+$/, '');

export const getMergedSearchParams = (): URLSearchParams => {
    const hash = window.location.hash || '';
    const hashQuery = hash.includes('?') ? hash.split('?')[1] : '';
    const mergedParams = new URLSearchParams(window.location.search);

    new URLSearchParams(hashQuery).forEach((value, key) => {
        const existingValue = mergedParams.get(key);
        const hasExistingValue = !!existingValue && existingValue.trim().length > 0;
        const hasIncomingValue = !!value && value.trim().length > 0;

        if (!hasExistingValue || hasIncomingValue) {
            mergedParams.set(key, value);
        }
    });

    return mergedParams;
};

export const getUrlParam = (key: string): string | null => {
    const mergedParams = getMergedSearchParams();

    if (mergedParams.has(key)) {
        return mergedParams.get(key);
    }

    const normalizedKey = key.toLowerCase();
    let matchingValue: string | null = null;

    mergedParams.forEach((paramValue, paramKey) => {
        if (matchingValue === null && paramKey.toLowerCase() === normalizedKey) {
            matchingValue = paramValue;
        }
    });

    return matchingValue;
};

export const isEmbedRoute = (): boolean => {
    const normalizedPath = normalizeRoute(window.location.pathname);
    return normalizedPath === 'embed';
};

export const isAppChannelParam = (channel: string | null | undefined): boolean => {
    if (!channel) {
        return false;
    }

    const normalizedChannel = channel.toLowerCase();
    return normalizedChannel === 'app' || normalizedChannel === 'mymtnapp';
};

export const isAppIntegrationRoute = (): boolean => {
    const normalizedPath = normalizeRoute(window.location.pathname);
    const hash = window.location.hash || '';
    const hashPath = normalizeRoute(hash.split('?')[0]?.replace(/^#/, '') || '');

    if (normalizedPath === 'mymtnapp' || hashPath === 'mymtnapp') {
        return true;
    }

    if (isEmbedRoute()) {
        return isAppChannelParam(getUrlParam('channel'));
    }

    return false;
};

export const splitName = (name: string | null | undefined): { firstName: string; lastName: string } => {
    if (!name || !name.trim()) {
        return { firstName: '', lastName: '' };
    }

    const parts = name.trim().split(/\s+/);
    return {
        firstName: parts[0] || '',
        lastName: parts.slice(1).join(' ')
    };
};

export const CHAT_SOURCE_STORAGE_KEY = 'chatSource';

export const getChatSource = (): string | null => {
    const sourceFromUrl = getUrlParam('source');
    if (sourceFromUrl?.trim()) {
        return sourceFromUrl.trim();
    }

    const storedSource = sessionStorage.getItem(CHAT_SOURCE_STORAGE_KEY);
    return storedSource?.trim() ? storedSource.trim() : null;
};

export const persistChatSource = (source: string | null | undefined): void => {
    if (source?.trim()) {
        sessionStorage.setItem(CHAT_SOURCE_STORAGE_KEY, source.trim());
    }
};
